import ExportEmployeesModal from 'modules/employees/components/ExportEmployeesTypeSelectionModal'
import { useOnCloseGoToList } from 'modules/employees/hooks/useOnCloseGoList'

const ExportEmployeesTypeSelectionModalPage = () => {
  const onClose = useOnCloseGoToList()

  return <ExportEmployeesModal onClose={onClose} />
}

export default ExportEmployeesTypeSelectionModalPage
